import { render, staticRenderFns } from "./SmChartStackedBar.vue?vue&type=template&id=23596a09&"
import script from "./SmChartStackedBar.vue?vue&type=script&lang=ts&"
export * from "./SmChartStackedBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports